import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { projectConfig } from '../../environments/environment';
import { Observable, Observer } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminService {

    public apiURL: string = projectConfig.apiURL;

    constructor(private http: HttpClient) {

    }

    getAllCategories() {
        const url = this.apiURL + 'categories_management/get_all_categories';
        return this.http.get<any>(url);
    }

    submitSubCategory(request: any) {
        const url = this.apiURL + 'categories_management/create_category';
        return this.http.post<any>(url, request);
    }

    deleteCategory(id: number): Observable<any> {
        const url = this.apiURL + 'categories_management/delete_category';
        return this.http.delete(`${url}/${id}`);
    }

    updateCategory(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'categories_management/update_category_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }
    
    createModel(request: any): Observable<any> {
        const url = this.apiURL + 'models_management/create_model';
        return this.http.post<any>(url, request);
    }
    
    updateModel(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'models_management/update_model';
        return this.http.put(`${url}/${id}`, updateData);
    }

    getAllModels(): Observable<any> {
        const url = this.apiURL + 'models_management/get_all_models';
        return this.http.get<any>(url);
        // return {
        //     "message": "Success",
        //     "data": [
        //         {
        //             "name": "gpt-4o",
        //             "id": 1,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "gpt-4o-mini",
        //             "id": 2,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "gpt-4o-na",
        //             "id": 3,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "gpt-4o-mini-na",
        //             "id": 4,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "claude-2",
        //             "id": 5,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "claude-3-haiku",
        //             "id": 6,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "claude-3-sonnet",
        //             "id": 7,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         },
        //         {
        //             "name": "claude-3.5-sonnet",
        //             "id": 8,
        //             "cloud_model": "aws bedrock",
        //             "is_active": true,
        //             "configuration": {}
        //         }
        //     ],
        //     "success": true
        // }
    }

    getPrompts(params: HttpParams): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/get_prompts_by_filters';
        return this.http.get<any>(url, { params });
    }

    rejectPrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }

    withdrawPrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }

    approvePrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }

    revokePrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }

    republishedPrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }
    
    archivePrompts(id: number, updateData:any): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/update_prompt_by_id';
        return this.http.put(`${url}/${id}`, updateData);
    }

    deletePrompt(id: number): Observable<any> {
        const url = this.apiURL + 'admin_prompt_manager/delete_prompt_by_id';
        return this.http.delete(`${url}/${id}`);
    }

    // user management
    getAllUsers(params: HttpParams): Observable<any> {
        const url = this.apiURL + 'user_management/get_all_users';
        return this.http.get<any>(url, { params });
    }

    updateUserStatus(updateData:any): Observable<any> {
        const url = this.apiURL + 'user_management/update_users_status';
        return this.http.put(`${url}`, updateData);
    }

    updateUserRoleCategory(updateData:any): Observable<any> {
        const url = this.apiURL + 'user_management/update_users_permissions';
        return this.http.put(`${url}`, updateData);
    }

    downloadAllUsers() {
        const url = this.apiURL + 'user_management/download_users';
        return url;
    }
    
    getDownloadAllUsers(passurl: string): Observable<Blob> {
        return this.http.get(passurl, { responseType: 'blob' });
      }

    getAllRoles(params: HttpParams): Observable<any> {
        const url = this.apiURL + 'user_management/get_users_by_role';
        return this.http.get<any>(url, { params });
    }
}